import { Chip, Stack, Typography } from "@mui/joy";
import { useTranslation } from "react-i18next";
import { IBusinessResponse } from "../../types/business";
import FlagById from "../../components/FlagById";
import { ShieldCheckIcon } from "@heroicons/react/24/solid";
import { theme } from "../../components/Theme";

type Props = {
  selectedBusiness: IBusinessResponse;
};

const ProfilePersonal = ({ selectedBusiness }: Props) => {
  const { t } = useTranslation();

  return (
    <Stack
      alignItems="stretch"
      direction="column"
      justifyContent="space-between"
      width={"100%"}
      sx={{ position: "relative" }}
      gap={"4px"}
    >
      {/* payment kyc snackbar */}
      {/* {selectedBusiness.kycPaymentGatewayStatus !== "VALIDATED" &&
        !BusinessSessionHelper.IsValidatedKYCPaymentGateway() && (
          <KycSnackBar />
        )} */}

      {/* toolbar */}
      <Typography level="text-sm-regular" sx={{ mt: "32px" }}>
        {t("profile.business.currentLoggedInCompanyTitle")}
      </Typography>

      {/* company name */}
      <Stack
        direction={"row"}
        sx={{
          justifyContent: "space-between",
          py: "10px",
          px: "16px",
          borderColor: theme.palette.neutral[300],
          borderWidth: "1px",
          borderRadius: "8px",
        }}
      >
        <Typography
          fontSize={"md"}
          startDecorator={
            <FlagById id={selectedBusiness.companyCountry ?? ""} />
          }
        >
          {selectedBusiness.companyName}
        </Typography>
        {selectedBusiness.id &&
          (selectedBusiness as any).kycPaymentGatewayStatus === "VALIDATED" && (
            <Chip
              color="success"
              startDecorator={<ShieldCheckIcon width={20} />}
              sx={{
                padding: "0.5rem",
                borderRadius: "0.5rem",
                marginLeft: {
                  xs: "1.5rem",
                  md: "0.5rem",
                },
              }}
              size="sm"
            >
              <Typography fontSize={"xs"} fontWeight={"sm"}>
                Validated
              </Typography>
            </Chip>
          )}
      </Stack>
    </Stack>
  );
};

export default ProfilePersonal;
